module.exports = __webpack_public_path__ + "img/project01.77892826.png";